export const MarkerMapModel = function (data) {
    if (!data) data = {};
    this.markupData = data.markupData || null;
    this.position = data.position || [];
    this.defaultPosition =data.defaultPosition || null;
    this.iconData=data.iconData || {};
    this.parentData=data.parentData || {};
};